import React, { useEffect, useRef, useState } from 'react';
import "./styles/cseData.css";
import CSEImage from "../departments/Mech Department.jpg";

const CseData = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  // References for the elements
  const totalBoysRef = useRef(null);
  const totalGirlsRef = useRef(null);
  const totalStaffRef = useRef(null);
  const totalStrengthRef = useRef(null);

  // Animation function to count up
  const animateValue = (start, end, elementRef) => {
    let current = start;
    const increment = Math.ceil(end / 100); // Adjust increment speed
    const interval = setInterval(() => {
      current += increment;
      if (current >= end) {
        current = end;
        clearInterval(interval);
      }
      if (elementRef.current) {
        elementRef.current.innerText = current;
      }
    }, 100); // 20ms interval for smoother animation
  };

  // Fetch hostel information
  useEffect(() => {
    fetch("https://gptkpm.in/backend/departments/code/get_me_info.php")
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "success" && result.data.length > 0) {
          const [fetchedData] = result.data;
          setData(fetchedData);

          // Trigger animations for fetched data
          animateValue(0, fetchedData.total_boys, totalBoysRef);
          animateValue(0, fetchedData.total_girls, totalGirlsRef);
          animateValue(0, fetchedData.staff, totalStaffRef);
          animateValue(0, fetchedData.total, totalStrengthRef);
        } else {
          setError(result.message || "No data available");
        }
      })
      .catch((err) => setError("Error fetching data: " + err.message));
  }, []);

  return (
    <div className="cse-data-container">
      {/* Hero Section */}
      <section className="hero-section">
        <img src={CSEImage} alt="Hostel Top" className="hero-image" />
        <div className="hero-content">
          <h1 className="welcome">Welcome to the Mechanical Engineering</h1>
        </div>
      </section>

      {/* Data Section */}
      <section className="data-section">
        {error && <p className="error-message">{error}</p>}
        {data && (
          <div className="info-container">
            <div className="info-item">
              <h2>Total Boys</h2>
              <p ref={totalBoysRef}>0</p>
            </div>
            <div className="info-item">
              <h2>Total Girls</h2>
              <p ref={totalGirlsRef}>0</p>
            </div>
            <div className="info-item">
              <h2>Total Staff</h2>
              <p ref={totalStaffRef}>0</p>
            </div>
            <div className="info-item">
              <h2>Total Students</h2>
              <p ref={totalStrengthRef}>0</p>
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default CseData;
